module.exports = __webpack_public_path__ + "img/lecturas.fc9267d0.svg";